// extracted by mini-css-extract-plugin
export default {"title":"Dealers_title__vEQ8+","tableContainer":"Dealers_tableContainer__b4c9v","search":"Dealers_search__J66AK"};